import { Component } from '@angular/core';
import { ReportShareComponent } from '../report-share.component';

@Component({
  selector: 'app-primary-style',
  templateUrl: './primary-style.component.html'
})
export class PrimaryStyleComponent extends ReportShareComponent {

  get html(): string {
    return this.report?.primaryCoachingStyleDesc?.replaceAll("\n", "<br />") ?? '';
  }

  get primaryStrength(): string {
    if (this.isFacilitatorTemplate) {
      return "OVERVIEW OF YOUR FACILITATOR STRENGTHS";
    } else if (this.isDirectReport) {
      return "OVERVIEW OF DIRECT REPORT PREFERRED STRENGTHS";
    } else if (this.isPeerToPeer) {
      return "OVERVIEW OF PEER PREFERRED STRENGTHS";
    } else if (this.isCoacheePreference) {
      return "OVERVIEW OF COACHEE PREFERRED STRENGTHS";
    }
    return "OVERVIEW OF YOUR COACHING STRENGTHS";
  }
}
